import React from "react";
import { apiRoutes } from "../../../hooks/apiClient";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import funcionalidades from "../../../context/AuthContext.funcionalidades";

const columns = [
  {
    name: "Nome",
    selector: "nome",
    width: "35%",
    sortable: true,
  },
  {
    name: "Ano",
    selector: "ano",
    maxWidth: "5%",
    sortable: true,
    center: true,
  },
  {
    name: "Descrição",
    selector: "descricao",
    width: "50%",
    sortable: true,
  },
];

const ConsultaCiclo = ({ history, match }) => (
  <PaginatedView
    title="Ciclos"
    keyField="codigo"
    descriptionField="descricao"
    defaultSearch
    defaultSearchPlaceholder="Digite a descrição"
    queryService={apiRoutes.fiscalizacao.parametrizacao.consultaCiclo}
    deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiCiclo}
    editRoute={`${match.url}/form`}
    columns={columns}
    permissionDelete={funcionalidades.ciclo.deletar}
    permissionInsert={funcionalidades.ciclo.inserir}
    history={history}
    reduxKey="ciclos"
  />
);

export default ConsultaCiclo;
